import CryptoJS from "crypto-js"
import moment from "moment";
// import { css } from '@emotion/css';
// import * as gl from "./const/gl.const"
import { PROD_SITE } from "./const/prod.const";

let abortController = new AbortController();

export const cancelAllPreviousFetchRequests = () => {
    // if (abortController) {
    //     abortController.abort();
    //     abortController = null;
    // }
    // abortController = new AbortController()
};

class Util {
    key;
    iv;
    sign_key;
    suffix;
    secretKey;
    // enter_sign_key;

    constructor() {
        this.key = "SWRUSnEwSGtscHVJNm11OGlCJU9PQCF2ZF40SyZ1WFc=";
        this.iv = "JDB2QGtySDdWMg==";
        this.sign_key = "JkI2OG1AJXpnMzJfJXUqdkhVbEU0V2tTJjFKNiUleG1VQGZO";
        this.suffix = 123456;
        this.secretKey = process.env.REACT_APP_SECRET_KEY;
        // this.enter_sign_key ="837885673";
    }
    base64encoder = function (t) {
        const e = CryptoJS.enc.Utf8.parse(t);
        return CryptoJS.enc.Base64.stringify(e)
    }

    encrypt = function (data, suffix = this.suffix) {
        let new_key = this.base64decoder(this.key);
        let new_iv = this.base64decoder(this.iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let encrypted = CryptoJS.AES.encrypt(data, new_key,
            {
                iv: new_iv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                formatter: CryptoJS.format.OpenSSL
            });
        return encrypted.toString();
    }

    decrypt = function (data, suffix = this.suffix) {
        let new_key = this.base64decoder(this.key);
        let new_iv = this.base64decoder(this.iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let decrypted = CryptoJS.AES.decrypt(data, new_key, {
            iv: new_iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            formatter: CryptoJS.format.OpenSSL
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }

    base64Sign = function (data) {
        data = this.objKeySort(data);
        let pre_sign = "";
        for (let i in data) {
            pre_sign += i + "=" + data[i] + "&";
        }
        let key = this.base64decoder(this.sign_key);
        pre_sign += key;
        return CryptoJS.MD5(pre_sign).toString();
    }

    objKeySort = function (arys) {
        let newObj = {};
        let newkey = Object.keys(arys).sort();
        for (var i = 0; i < newkey.length; i++) {
            newObj[newkey[i]] = arys[newkey[i]];
        }
        return newObj;
    }

    toFmt = function (t) {
        return t ? moment(t).format("YYYY-MM-DD") : t
    }
    fmtDateSince = (date) => {
        let seconds = Math.floor((+new Date() - +new Date(date)) / 1000)
      
        let interval = seconds / 31536000
        // years
        if (interval > 1) {
          return moment(date).format('YYYY-MM-DD')
        }
        // months
        interval = seconds / 2592000
        if (interval > 1) {
        //   return moment(date).format('YYYY-MM-DD')
            return Math.floor(interval) + ' 个月前'
        }
      
        // days
        interval = seconds / 86400
        // if (interval > 7) {
        //   return moment(date).format('YYYY-MM-DD')
        // }
        // if (interval > 1 && interval <= 7) {
        if (interval > 1) {
          return Math.floor(interval) + ' 天前'
        }
        // hours
        interval = seconds / 3600
        if (interval > 1) {
          return Math.floor(interval) + ' 小时前'
        }
        // minutes
        interval = seconds / 60
        if (interval > 1) {
          return Math.floor(interval) + ' 分钟前'
        }
        //seconds
        return Math.floor(seconds) + ' 秒'
      }

    // logout = function () {
    //     localStorage.removeItem("_USER");
    //     userInfo$.next({});
    //     return window.location.href = "/main"
    // }
    // initHls = () => {
    //     const hlsOpt = (vid) => {
    //         return {
    //             container: vid,
    //             video: {
    //                 url: vid.getAttribute("src"),
    //                 type: 'auto',
    //                 defaultQuality: 0,
    //             }
    //         }
    //     }

    //     const allVid = document.getElementsByClassName('buy_post_vid');
    //     for (let i = 0; i < allVid.length; i++) {
    //         const __el = document.getElementById(allVid[i].id);
    //         new Dp(hlsOpt(__el))
    //     }
    // }

    isMobile = function () {
        return window.matchMedia("only screen and (max-width: 700px)").matches;
    };

    isLogin = () => {
        try {
            let __data = localStorage.getItem("_USER");
            __data = JSON.parse(u.decrypt(__data))
            return !!__data?.token
        } catch (error) {
            return false
        }
    }

    isVip = () => {
        try {
            let __data = localStorage.getItem("_USER");
            __data = JSON.parse(u.decrypt(__data))
            return parseInt(__data.vip_level) > 0 && (parseInt(__data.is_vip) === 2 || parseInt(__data.val_time) * 1000 > new Date().getTime())
        } catch (error) {
            return false
        }
    }

    isPC = () => {
        var userAgentInfo = navigator.userAgent;
        var agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
        var flag = true;
        for (var i = 0; i < agents.length; i++) {
            if (userAgentInfo.indexOf(agents[i]) > 0) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    isAndroid = () => {
        var userAgentInfo = navigator.userAgent;
        return userAgentInfo.indexOf("Android") > -1 || userAgentInfo.indexOf("Linux") > -1;
    }

    isiOS = () => {
        var userAgentInfo = navigator.userAgent;
        return !!userAgentInfo.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    }

    getDeviceType = () => {
        if (this.isPC()) {
            return "pc"
        }
        if (this.isAndroid()) {
            return "android"
        }
        if (this.isiOS()) {
            return "ios"
        }
        return ""
    }
    reload = () => {
        return window.location.reload()
    }
    rand = (list) => {
        return list.sort(() => Math.random() - 0.5);
    }
    fetcher = (...args) => fetch(...args).then((res) => res.json());
    imgDecrypt = (data) => {
        try {
            const asc_key = "jeH3O1VX";
            const base_lv = "nHnsU4cX";
            const tmpiv = CryptoJS.enc.Utf8.parse(base_lv);
            const keyHex = CryptoJS.enc.Utf8.parse(asc_key);
            const decrypted = CryptoJS.DES.decrypt({
                ciphertext: CryptoJS.enc.Base64.parse(data)
            }, keyHex, {
                iv: tmpiv,
                mode: CryptoJS.mode.CBC,
                padding: CryptoJS.pad.Pkcs7,
                formatter: CryptoJS.format.OpenSSL
            });
            return decrypted.toString(CryptoJS.enc.Utf8);
        } catch {
            return ''
        }
    }
    // 更多搜索跳转
    searchIdByChannel = (categoryList, channel, name) => {
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        const selectedRow = selectedChannel.find((x) => x.name === name);
        return selectedRow;
    }
    searchIdByChannelAndId = (categoryList, channel, id) => {
        let _id = id;
        try {
            _id = parseInt(_id)
        } catch {
            _id = id;
        }
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        const selectedRow = selectedChannel.find((x) => x.id === _id);
        return selectedRow;
    }
    searchIndexIdByChannel = (categoryList, channel) => {
        const selectedChannel = categoryList.find((x) => x.channel === channel)?.data || [];
        return selectedChannel;
    }
    searchHomecategory = (categoryList, channel, name) => {
        const value = categoryList.find((x) => x.channel === channel && x.name === name);
        if (value) {
            return value
        }

        const value1 = categoryList.find((x) => x.channel === channel)?.data || [];
        return value1.find((x) => x.name === name)
    }
    searchIsParentList = (categoryList, channel, id) => {
        const blcaklistid = [4, 6]; // 父级板块但是调用的是list/base
        let _id = id;
        try {
            _id = parseInt(_id)
        } catch {
            _id = id;
        }
        const row = categoryList.find((x) => x.channel === channel && x.id === _id);
        return {
            pname: row?.name,
            isMain: !!row?.name && !blcaklistid.includes(row?.id)
        }
    }

    // percentJump = (id) => {
    //     const categoryConditionMap = {
    //         12: {
    //             name: "女友专区",
    //             condition: gl.default.jump_ins.jump,
    //             url: gl.default.jump_ins.url
    //         },
    //         142: {
    //             name: "岛国有码",
    //             condition: gl.default.jump_ins.jump,
    //             url: gl.default.jump_ins.url
    //         },
    //         143: {
    //             name: "岛国无码",
    //             condition: gl.default.jump_ins.jump,
    //             url: gl.default.def_wuma_ins
    //         }
    //     }
    //     return categoryConditionMap[id]?.condition ? categoryConditionMap[id].url : false;
    // }
    /**
     * @param {*} main 是否是大板块
     * @returns 
     */
    mapCategoryRoute = (router, main = false, channel, id, token = false) => {
        let _path = ""

        // if (id === 57 && !token) {
        //     _path = `/login`
        // }
        // if (id === 57 && token) {
        //     _path = `/user/buy`
        // }
        if (main) {
            _path = `/page/c/${channel}/${id}`
        }
        // if (["vip"].includes(channel) && !this.isVip()) {
        //     _path = `/user/buy`
        //     return window.open(_path)
        // }
        // if (["vip"].includes(channel) && !token) {
        //     _path = `/login`
        //     return window.open(_path)
        // }

        // 概率跳转
        // const isMatch = Math.floor(Math.random() * 4) === 3;
        // const res = this.percentJump(id);

        // if (isMatch && res) {
        //     return window.open(res)
        // }
        if (["vip"].includes(channel)) {
            _path = `/page/vip/${id}`
        }
        if (["shipin"].includes(channel)) {
            _path = `/page/shipin/${id}`
        }
        if (["cili"].includes(channel)) {
            _path = `/page/cili/${id}`
        }

        if (["tupian",].includes(channel)) {
            _path = `/page/tupian/${id}`
        }
        if (["meinv"].includes(channel)) {
            _path = `/page/meinv/${id}`
        }
        if (["xiaoshuo"].includes(channel)) {
            _path = `/page/xiaoshuo/${id}`
        }
        if (["yousheng"].includes(channel)) {
            _path = `/page/yousheng/${id}`
        }

        return window.open(_path)
    }
    // randomHash = () => {
    //     const hash = Math.random().toString(36).substring(7);
    //     return css``;
    // };

    decryptAnother = function (data, suffix = 883346) {
        const key = "SWRUSnEwSGtscHVJNm11OGlCJU9PQCF2ZF40SyZ1WFc=";
        const iv = "JDB2QGtySDdWMg==";

        let new_key = this.base64decoder(key);
        let new_iv = this.base64decoder(iv);
        new_iv = CryptoJS.enc.Utf8.parse(new_iv + suffix);
        new_key = CryptoJS.enc.Utf8.parse(new_key);
        let decrypted = CryptoJS.AES.decrypt(data, new_key, {
            iv: new_iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
            formatter: CryptoJS.format.OpenSSL
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    fmtSze = function (x) {
        const units = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        let l = 0, n = parseInt(x, 10) || 0;
        while (n >= 1024 && ++l) {
            n = n / 1024;
        }
        return (n.toFixed(n < 10 && l > 0 ? 1 : 0) + ' ' + units[l]);
    }
    getGB = function (value) {
        var gb = value / (1024 * 1024 * 1024);
        return gb.toFixed(2) + 'GB';
    }
    osType = function () {
        var userAgent = navigator.userAgent;
        if (userAgent.indexOf('Mac') !== -1) {
            return 0
        } else if (userAgent.indexOf('Win') !== -1) {
            return 1
        } else {
            return 2
        }
    }
    executePromisesInBatches = async (promises) => {
        const batchSize = 5;
        const batches = Math.ceil(promises.length / batchSize);
        for (let i = 0; i < batches; i++) {
            const batch = promises.slice(i * batchSize, (i + 1) * batchSize);
            await Promise.all(batch);
        }
    }
    fetchData = async (url) => {
        try {
            const signal = abortController.signal;
            const response = await fetch(url, { signal });
            const data = await response.text();
            return data;
        } catch {
            return ""
        }
    }

    fetchInBatches = async (urls, updateState, keyFn) => {
        if (urls.length === 0) return;
        // const maxBatchSize = 5;
        const totalUrls = urls.length;
        const batches = Math.ceil(totalUrls / 5);
        const batchSize = Math.ceil(totalUrls / batches);
        const batchResults = [];
        let objBatchResults = {};
        for (let i = 0; i < batches; i++) {
            const batchUrls = urls.slice(i * batchSize, (i + 1) * batchSize);
            const promises = batchUrls.map(this.fetchData);
            const results = await Promise.all(promises);
            
            const decrypt = results.map((x) => {
                try {
                    return u.imgDecrypt(x)
                } catch {
                    return ''
                }
            })

            if (keyFn) {
                objBatchResults = { [keyFn()]: decrypt }
            } else {
                batchResults.push(...decrypt);
            }

            if (updateState) {
                if (keyFn) {
                    updateState(objBatchResults)
                } else {
                    updateState([...batchResults]);
                }
            }
        }
        return batchResults;
    }
    countdown = (fn) => {
        let targetTime = new Date();
        targetTime.setHours(24, 0, 0);
        fn("24:00:00")

        const countdownInterval = setInterval(() => {
            const currentTime = new Date().getTime();
            let timeDifference = targetTime - currentTime;

            if (timeDifference <= 0) {
                clearInterval(countdownInterval);
                this.countdown();
            } else {
                const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
                const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
                const seconds = Math.floor((timeDifference / 1000) % 60);
                fn(`${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`)
            }
        }, 1000);
    }
    // temp use code2
    getCode = () => {
        let downloadDiv = document.getElementById("code2");
        const img1 = document.getElementById('qrcode_img_hide');
        if (downloadDiv) {
            downloadDiv.addEventListener('click', function () {
                var link = document.createElement('a');
                link.href = img1.src;
                link.download = 'new_pic.png';
                link.click();
            });
        }
    }
    base64decoder = function (Context) {
        let tmp = CryptoJS.enc.Base64.parse(Context); // encryptedWord via Base64.parse()
        return CryptoJS.enc.Utf8.stringify(tmp);
    }
    back = () => {
        const _l = window.location.href;
        if (_l.indexOf("chapter/xiaoshuo") >= 0) {
            const match = _l.match(/\/(\d+)\/[^/]*$/);
            const value = match ? match[1] : null;
            return window.open(`/page/xiaoshuo/${value}`)
        }
        if (_l.indexOf("/user") >= 0) {
            return window.open("/main")
        }
    }
    getLocalData = (key) => {
        try {
            const __data = localStorage.getItem(key);
            let val = JSON.parse(u.decrypt(__data))
            return val
        } catch (error) {
            return {}
        }
    }
    // older verion entry required url to be url?user=  
    formUser = (type, data) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }

        let _path = "";
        if (type == EVIPtype.BUY) {
            _path = "user/buy.html"
        }
        if (type == EVIPtype.VIP) {
            _path = "vip/index.html"
        }

        const url = `${_vip}/${_path}?user=${this.encrypt(JSON.stringify(data), 'djasjl')}`
        return window.open(url)
    }
    formLogin = (str) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }
        // const isTrue = process.env.NODE_ENV !== 'production';
        // _vip = isTrue ? "/login" : `${_vip}/user/login.html`;

        if (str) {
            return _vip
        }

        return window.open(_vip)
    }
    formRegister = (str) => {
        const _baseData = this.getLocalData(ELocalKey._BASE);
        let _vip = _baseData?.vip_domain;
        if (_vip && _vip.slice(-1) === '/') {
            _vip = _baseData.slice(0, -1);
        }
        const isTrue = process.env.NODE_ENV !== 'production';
        _vip = isTrue ? "/register" : `${_vip}/user/register.html`;;

        if (str) {
            return _vip
        }
  
        return window.open(_vip)
    }
    getStatsParams = (isTop, channel, name, currentUrl, isyq, isMobYq) => {
        // currentUrl 广告mapping
        const adsMapping = {
            tese: 101,
            index: 99, // home
            main: 99,
            vip: 10,
            shipin: 20,
            cili: 30,
            tupian: 40,
            meinv: 50, // lulutuqu
            xiaoshuo: 60,
            yousheng: 70,
            "app-down": 99,
            news: 99,
            // 以下不是channel 统一处理
            "猫咪头条": 81,
            // "91大神网": 82,
            "直播视频": 82,
            "女优大全": 83,
            "麻豆系列": 84,
            "P站高清": 85,
            "成人论坛": 86,
            "海角社区": 87,
            "G友原创": 88
        }

        const defaultParams = {
            category: isTop ? "top" : channel,
            device: this.getDeviceType(),
            domain: window.location.host,
            site: `${PROD_SITE}_1`,
            system: this.isMobile() ? 2 : 1,
            timestamp: moment().valueOf()
        }
        if (name) {
            defaultParams["name"] = name;
        }
        if (currentUrl) {
            let _selected = "";
            let _channel = ""
            for ( let i in adsMapping) {
                if (currentUrl.indexOf(i) >= 0) {
                    _selected = adsMapping[i];
                    _channel = i === "main" ? "index" : i
                    break;
                }
            }
            defaultParams["c"] = _selected;
            defaultParams["category"] = isTop ? "top" : _channel;

            if (_selected >= 81 && _selected <= 88 && !isTop) {
                defaultParams["category"] = "tesezhuanqu";
            }
            if (isTop)
            delete defaultParams["channel"];

        }
        if (isyq) {
            defaultParams["c"] = 98;
        }
        if (isMobYq) {
            defaultParams["category"] = "youqingtuijian";
            delete defaultParams["c"]
        }
        return defaultParams
    }
    themeBtnCls = () => {
        return PROD_SITE === 3 ? "theme_orange" : PROD_SITE === 2 ? "theme_blue" : "theme_oringinal"
    }
    themeHeader = () => {
        return !this.isPC() ? PROD_SITE === 3 ? "header_orange" : PROD_SITE === 2 ? "header_blue" : "header_oringinal" : ''
    }
    dot = (word) => {
        if (!word) return;
        return `${word.slice(0, 35)}...`
    }
    clearExpireLocalStorage = () => {
        let hours = 1;
        let now = Date.now();
        let setupTime = localStorage.getItem('setupTime');
        if (setupTime == null) {
            localStorage.setItem('setupTime', now.toString())
        } else if ((now - parseInt(setupTime)) > hours*60*60*1000) {
            localStorage.clear()
            localStorage.setItem('setupTime', now.toString());
        }
    }

    kefuOpen = () => {
        let _url = u.formLogin(true);
        const val = u.getLocalData(ELocalKey._BASE)?.customer_service_url;
        if (val) {
            return window.open(val, '_blank')
        }
        // if (this.isLogin()) {
        //     let __data = localStorage.getItem(ELocalKey._USER);
        //     try {
        //         __data = JSON.parse(decrypt(__data))
        //     } catch {
        //         window.open(_url)    
        //     }
        //     window.open(__data?.custom_url || _url)
        // }
        return window.open(_url, '_blank')
      }

    tgOpen = () => {
        const val = u.getLocalData(ELocalKey._BASE)?.contact_telegram;
        if (val) {
            return window.open(val, '_blank')
        }
        return;
      }

    randomNumberInRange = (min, max) =>{
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }

    documentWriteStatisticsScript = (domain = "https://sta.zuhuaizhijia.com") => {
      let hm = document.createElement("script");
      hm.innerHTML = `!function(){"use strict";!function(t){var e=t.screen,n=e.width,r=e.height,a=t.navigator.language,i=t.location,o=t.localStorage,u=t.document,c=t.history,f=i.hostname,s=i.pathname,l=i.search,d=u.currentScript;if(d){var m="data-",h=d.getAttribute.bind(d),v=(h(m+"host-url"),"false"!==h(m+"auto-track")),p=h(m+"do-not-track"),g=h(m+"domains")||"",b=g.split(",").map((function(t){return t.trim()})),y=n+"x"+r,S=/data-umami-event-([\\w-_]+)/,k=m+"umami-event",j=function(t,e,n){var r=t[e];return function(){for(var e=[],a=arguments.length;a--;)e[a]=arguments[a];return n.apply(null,e),r.apply(t,e)}},w=function(){return{website:"af9a3624-d08c-4b13-b7c5-1b79c2236e89",hostname:f,screen:y,language:a,title:q,url:P,referrer:document.referrer}},N=function(){return o&&o.getItem("umami.disabled")||p&&function(){var e=t.doNotTrack,n=t.navigator,r=t.external,a="msTrackingProtectionEnabled",i=e||n.doNotTrack||n.msDoNotTrack||r&&a in r&&r[a]();return"1"==i||"yes"===i}()||g&&!b.includes(f)},T=function(t,e,n){n&&(_=P,(P=function(t){try{return new URL(t).pathname}catch(e){return t}}(n.toString()))!==_&&setTimeout(x,300))},A=function(t,e){if(void 0===e&&(e="event"),!N()){var n={"Content-Type":"application/json"};return void 0!==E&&(n["x-umami-cache"]=E),fetch("${domain}/api/send",{method:"POST",body:JSON.stringify({type:e,payload:t}),headers:n}).then((function(t){return t.text()})).then((function(t){return E=t})).catch((function(){}))}},x=function(t,e){return A("string"==typeof t?Object.assign({},w(),{name:t,data:"object"==typeof e?e:void 0}):"object"==typeof t?t:"function"==typeof t?t(w()):w())};t.umami||(t.umami={track:x,identify:function(t){return A(Object.assign({},w(),{data:t}),"identify")}});var E,O,L,D,K,P=""+s+l,_=u.referrer,q=u.title;if(v&&!N()){c.pushState=j(c,"pushState",T),c.replaceState=j(c,"replaceState",T),K=function(t){var e=t.getAttribute.bind(t),n=e(k);if(n){var r={};return t.getAttributeNames().forEach((function(t){var n=t.match(S);n&&(r[n[1]]=e(t))})),x(n,r)}return Promise.resolve()},u.addEventListener("click",(function(t){var e=t.target,n="A"===e.tagName?e:function(t,e){for(var n=t,r=0;r<10;r++){if("A"===n.tagName)return n;if(!(n=n.parentElement))return null}return null}(e);if(n){var r=n.href,a="_blank"===n.target||t.ctrlKey||t.shiftKey||t.metaKey||t.button&&1===t.button;if(n.getAttribute(k)&&r)return a||t.preventDefault(),K(n).then((function(){a||(i.href=r)}))}else K(e)}),!0),L=new MutationObserver((function(t){var e=t[0];q=e&&e.target?e.target.text:void 0})),(D=u.querySelector("head > title"))&&L.observe(D,{subtree:!0,characterData:!0,childList:!0});var C=function(){"complete"!==u.readyState||O||(x(),O=!0)};u.addEventListener("readystatechange",C,!0),C()}}}(window)}();`;
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    }

    documentInsertStatisticsScript = (domain = "https://sta.zuhuaizhijia.com") => {
      localStorage.setItem('statistics_domain',domain);
      let hm = document.createElement("script");
      hm.src = './statistics-script.js';
      hm.async = true;
      let s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    }
    addImgKeyParam = function (url) {
        let secret_key = this.secretKey;
        let currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
        let storedTime = sessionStorage.getItem('timestamp'); // Get the stored timestamp from sessionStorage

        let time; // Declare the time variable

        // If there is a stored time and 5 minutes haven't passed, reuse the stored time
        if (storedTime && currentTime - parseInt(storedTime) < 300) {
            time = parseInt(storedTime) + 300; // Use the stored timestamp and add 300 seconds
        } else {
            // If no stored time or more than 5 minutes have passed, generate a new timestamp
            time = currentTime + 300; // Add 300 seconds to the current time
            sessionStorage.setItem('timestamp', currentTime.toString()); // Store the new timestamp in sessionStorage
        }

        // let hexTime = time.toString(16); // 转换为十六进制字符串
        // let uri = "/xmmvip/xmmvip/e73172371207066dc2d5ad72f2__289916/e73172371207066dc2d5ad72f2__289916_thumb_5903.jpg"

        // The URI for which we're generating the key
        let uri = url;

        // Concatenate secret_key, uri, and time (decimal) for the MD5 hash
        let paramToAppend = secret_key + uri + time; // 确保这里是十六进制
        
        let key = CryptoJS.MD5(paramToAppend).toString(); // 使用CryptoJS计算MD5

        return '?wsSecret=' + key + "&wsTime=" + time; // 使用十六进制时间戳
    }
}
const u = new Util();
export default u

export const ELocalKey = {
    _BASE: "_BASEPIC",
    _CATER: "_CATERPIC",
    _BANNER: "_BANNERPIC",
    _INDEXLIST: "_INDEXLISTPIC",

    
    // _CONF: "_CONF",
    // _USER: "_USER",
    // _BROWSE: "_BROWSER",
    // _TESE: "_TESE"
}

export const EVIPtype = {
    VIP: "VIP",
    BUY: "BUY",
}